import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { useEffect, useState } from "react";
import Footer from "./components/Footer";
import Header from "./components/Header";
import { AnimationProvider } from "./contexts/AnimationContext";
import Login from "./pages/LoginPage";
import Home from "./sections/Home";
import Registry from "./sections/Registry";
import RSVP from "./sections/RSVP";
import TravelAndStay from "./sections/TravelAndStay";
import theme from "./theme";

function App() {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Preload hero image
    const mainImg = new Image();
    mainImg.src =
      "https://res.cloudinary.com/dzwnnnku5/image/upload/v1770333079/azores_lagoon_color_v7l9q0.jpg";

    const fallbackImg = new Image();
    fallbackImg.src =
      require("./assets/images/azores_lagoon_color_red1.webp").default;
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AnimationProvider>
        <div>
          {isUserLoggedIn ? (
            <>
              <Header />
              <Home />
              <TravelAndStay />
              <Registry />
              <RSVP />
              <Footer />
            </>
          ) : (
            <Login onLogin={() => setIsUserLoggedIn(true)} />
          )}
        </div>
      </AnimationProvider>
    </ThemeProvider>
  );
}

export default App;
